import ReactDOM from 'react-dom/client'
import App from './components/App/App'
import "./ftue.css"
import "./global.css"


ReactDOM.createRoot(document.getElementById('root')).render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>,
)
